class CustomCombobox extends HTMLElement {
  #trigger = null;
  #dropdown = null;

  connectedCallback() {
    this.#trigger = this.querySelector('[data-ref="trigger"]');
    this.#dropdown = this.querySelector('[data-ref="dropdown"]');

    this.#trigger.addEventListener('click', this.#onTriggerClick);

    document.addEventListener('click', this.#onDocumentClick);
    document.addEventListener('keydown', this.#onDocumentKeydown);
  }

  disconnectedCallback() {
    this.#trigger?.removeEventListener('click', this.#onTriggerClick);

    document.removeEventListener('click', this.#onDocumentClick);
    document.removeEventListener('keydown', this.#onDocumentKeydown);

    this.#trigger = null;
    this.#dropdown = null;
  }

  get #isOpen() {
    return this.#trigger?.getAttribute('aria-expanded') === 'true';
  }

  open() {
    this.#trigger.setAttribute('aria-expanded', 'true');
    this.#dropdown.removeAttribute('hidden');
  }

  close() {
    this.#trigger.setAttribute('aria-expanded', 'false');
    this.#dropdown.setAttribute('hidden', '');
  }

  toggle() {
    this.#isOpen ? this.close() : this.open();
  }

  #onTriggerClick = (event) => {
    event.stopPropagation();
    this.toggle();
  };

  #onDocumentClick = ({ target }) => {
    if (target instanceof Node && !this.contains(target)) {
      this.close();
    }
  };

  #onDocumentKeydown = ({ key }) => {
    if (!this.#isOpen) return;

    switch (key) {
      case 'Escape':
        this.close();
        this.#trigger.focus();
        break;
      case 'Tab':
        this.close();
        break;
    }
  };
}

if (!customElements.get('custom-combobox')) {
  customElements.define('custom-combobox', CustomCombobox);
}
